import { ContactType, OrganizationType } from "types/enum";
import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";




// export const getCustomerPhoneDictionaryApi = (async (id ,personId ,Current) => await http({
//     url: Current ?  ENDPOINTS.BaseInformation.CurrentPersonContact.phones  :    ENDPOINTS.BaseInformation.PersonContact.phones,
//     method: 'get',
//     params: {
//         personId:personId,
//         id: id,
//     }
// }).then((res) => {

//     return res.data.Data
// }).catch((err) => {

//     return Promise.reject( err);
// })
// )


export const getCustomerPhoneDictionaryListApi = (async (search,id ,CustomerPositionId ,Current,type=1) => await http({
    url: Current ?  
    type===ContactType.Phone?
    ENDPOINTS.BaseInformation.CurrentPersonContact.phoneDictionary
    :ENDPOINTS.BaseInformation.CurrentPersonContact.mobileDictionary :
    type===ContactType.Phone?
    ENDPOINTS.BaseInformation.CustomerPosition.phoneDictionary
    :ENDPOINTS.BaseInformation.CustomerPosition.mobileDictionary,
    method: 'get',
    params: {
        CustomerPositionId,
        searchString:search
    }
}).then((res) => {

    return res.data.Data
}).catch((err) => {

    return Promise.reject( err);
})
)